import ChangeAppointment from "./ChangeAppointment";
import { useEffect, useState } from "react";

import AppointmentListNew1 from "./AppointmentListNew1";



import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AppointmentDetails from "./AppointmentDetails";
import { Box, Grid2 } from "@mui/material";
import PrescriptionForm from "../Prescriptions/PrescriptionForm";
import NewAppointment1 from "./NewAppointment1";
import { useSnackbar } from "../Utility/UserMessageContext";
import NewVisit from "./NewVisit";
import EditVisit from "./EditVisit";
;
// import AppointmentTable1 from './AppointmentTable2'; 
// import './app1.css';


function AppointmentsHome1() {
  const [value, setValue] = React.useState("Visits"); // Current selected tab
  // const [tabs, setTabs] = React.useState([
  //   { label: 'Visits', value: "Visits" },
  //   // { label: '', value: 2 },
  //   // { label: 'Phone', value: 3 },
  // ]); // Fixed tabs: Home, Contact, and Phone
  const [tabs, setTabs] = React.useState(() => {
    // Load tabs from local storage
    const savedTabs = localStorage.getItem('visits-tabs');
    return savedTabs ? JSON.parse(savedTabs) : [{ label: 'Visits', value: "Visits", type:"visit-list" }];
  });
  const [newAppointments, setNewAppointments] = useState([]);

  const [newAppointmentTabNumber, setNewAppointmentTabNumber] = useState(-1);
  const {showSnackbar} = useSnackbar();


  //const[newPrescriptionNumber, setNewPrescriptionNumber] = useState(-1);
  const [newPrescriptionTabNumber, setNewPrescriptionTabNumber] = useState(-1);

  useEffect(() => {
    // Save tabs to local storage whenever they change
    //var tabsToBeSaved = tabs.filter((t) => t.type !== "new-visit");
    localStorage.setItem('visits-tabs', JSON.stringify(tabs));
  }, [tabs]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  }; 

  const handleViewDetails = (appointmentData) => {
    // Check if the tab is already open
    const existingTab = tabs.find((tab) => tab.value === appointmentData.id);

    if (existingTab) {
      // If the tab exists, switch to it
      setValue(existingTab.value);
    } else {
      // Create a new tab if it doesn't exist
      const newTab = {
        label: appointmentData?.displayId,
        value: appointmentData?.id,
        type:"visit-details",
        props: JSON.stringify(appointmentData), 
      };

      setTabs((prevTabs) => [...prevTabs, newTab]);
      setValue(appointmentData?.id); // Switch to the newly added tab
    }
  };

  const handleNewPrescription = (appointmentId) => {
    const newTabNumber = newPrescriptionTabNumber + 1;
    setNewPrescriptionTabNumber(newTabNumber);
    
    //const existingTab = tabs.find((ta b) => tab.value === "NewAppointment");

    // if (existingTab) {
    //   // If the tab exists, switch to it
    //   setValue(existingTab.value);
    // } else {
      //Create a new tab if it doesn't exist
      //const newTabValue = tabs.length + 1; // Assign a unique value for the new tab
      const newTab = {
        label: newTabNumber === 0 ? "New Prescription" : "New Prescription (" + newTabNumber + ")",
        value: "NewPrescription"+ newTabNumber,
        content: (
            <PrescriptionForm key={newTabNumber} appointmentId={appointmentId} mode="new"/>
        ),
      };
    
      setTabs((prevTabs) => [...prevTabs, newTab]);
      setValue("NewPrescription"+ newTabNumber); // Switch to the newly added tab
    
  };

  const handleNewAppointment = (visitType) => {
    // Check if the tab is already open
    var newTabNumber = 0;
    var newTabValue = "NewVisit"+ newTabNumber;
    while (tabs.find((tab) => tab.value === newTabValue)) {
      newTabNumber++;
      newTabValue = "NewVisit"+ newTabNumber;
    }

    setNewAppointmentTabNumber(newTabNumber);
    
    //const existingTab = tabs.find((tab) => tab.value === "NewAppointment");

    // if (existingTab) {
    //   // If the tab exists, switch to it
    //   setValue(existingTab.value);
    // } else {
      //Create a new tab if it doesn't exist
      //const newTabValue = tabs.length + 1; // Assign a unique value for the new tab
      const newTab = {
        label: newTabNumber === 0 ? `New Visit (${visitType})` : `New Visit (${visitType}) (${newTabNumber})`,
        value: "NewVisit"+ newTabNumber,
        type:"new-visit",
        props: {visitType: visitType},
      };
    
      setTabs((prevTabs) => [...prevTabs, newTab]);
      setValue("NewVisit"+ newTabNumber); // Switch to the newly added tab
    
  };

  const handleEditVisit = (visit) => {
      const newTab = {
        label: `Edit (${visit?.displayId})`,
        value: "EditVisit"+ visit?.id,
        visit: visit,
        type:"edit-visit",
      };
    
      setTabs((prevTabs) => [...prevTabs, newTab]);
      setValue(newTab.value); // Switch to the newly added tab
    
  };

  const handleCloseTab = (tabValue) => {
    // Prevent closing fixed tabs
    if (tabValue === "Visits") return;

    const remainingTabs = tabs.filter((tab) => tab.value !== tabValue);

    setTabs(remainingTabs);
    setValue(remainingTabs[remainingTabs.length - 1].value); // Switch to the last tab
    localStorage.removeItem(tabValue);
  };

  return (
    <Grid2 container>
      <TabContext value={value}>
      <Grid2 container size={12} alignItems="center" spacing={1}  sx={{ borderBottom: "1px solid lightgray", width: "100%" }}>
      <Tabs value={value} onChange={handleChange} variant="scrollable">
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            label={
              <Box>
                {tab.label}
                {tab.value !== "Visits" && ( // Show close button only for dynamic tabs
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent triggering tab change
                      handleCloseTab(tab.value);
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
            value={tab.value}
          />
        ))}
      </Tabs>
      </Grid2>

  
      {tabs.map((tab) => (
              
        <TabPanel key={tab.value} value={tab.value} sx={{padding:'0px', width:'100%'}} keepMounted={tab.value !== "Visits"}>
          {tab.type === "visit-list" && <AppointmentListNew1 onViewDetails={handleViewDetails} onAddNewAppointment={handleNewAppointment} onAddNewPrescription = {handleNewPrescription} 
          onEditVisit={handleEditVisit}
          />}

          {/* {tab.value !== "Visits" && tab.content} */}
          {tab.type === "visit-details" && <AppointmentDetails key={tab?.value} selectedAppointment = {tab?.props && JSON.parse(tab?.props)}/>}
          {tab.type === "new-visit" && <NewVisit key={tab?.value} newAppointmentTempId={tab?.value} visitType={tab?.props?.visitType} closeTab={handleCloseTab} />}
          {tab.type === "edit-visit" && <EditVisit key={tab?.value} visit={tab?.visit} closeTab={handleCloseTab} />}
        </TabPanel>
      ))}
    </TabContext>
    </Grid2>
  );
}


export default AppointmentsHome1;
